import { logTypes } from '@/assets/scripts/dictionaries';

// Report keys of the assistant -> report pages of the web interface.
const REPORT_ROUTES = {
  worktime_summary: 'summaryUserReport',
  productivity: 'summaryUserReport',
  violations: 'disciplineViolations',
  activity_feed: 'activityFeed',
  worktime_daily: 'worktimeDetails',
  mail_stats: 'mail',
  messengers_stats: 'messengers',
  programs_stats: 'programs',
  websites_stats: 'websites',
  printing_stats: 'docStat',
  file_transfer_summary: 'files',
};

const LOG_IDS = logTypes.reduce((result, log) => ({ ...result, [log.slug]: log.id }), {});

// Times are wall-clock "YYYY-MM-DD HH:MM:SS" of the monitored computer: no time zone conversion.
const pad = (value) => String(value).padStart(2, '0');
const stamp = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
  `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;

function parse(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/.exec(String(value || ''));
  if (!match) return null;
  const [, y, m, d, hh, mm, ss] = match;
  return new Date(Number(y), Number(m) - 1, Number(d), Number(hh), Number(mm), Number(ss || 0));
}

const normalize = (value) => (value ? String(value).replace('T', ' ').slice(0, 19) : undefined);

/** The day of the record: the log page opens on that date with the record selected. */
export function recordLink(item) {
  if (!item || !item.linkSource || !item.computerId || !LOG_IDS[item.linkSource]) return null;
  const moment = parse(item.time);
  if (!moment) return null;
  const day = item.time.slice(0, 10);
  return {
    name: 'computers-computer-log-record',
    params: {
      computer: String(item.computerId),
      log: item.linkSource,
      ...(item.recordId ? { record: String(item.recordId) } : {}),
    },
    query: { dateFrom: `${day} 00:00:00`, dateTo: `${day} 23:59:59` },
  };
}

/** Event stream of the computer around the record (±10 minutes). */
export function streamLink(item) {
  if (!item || !item.linkSource || !item.computerId || !LOG_IDS[item.linkSource]) return null;
  const moment = parse(item.time);
  if (!moment) return null;
  return {
    name: 'advanced',
    query: {
      dateFrom: stamp(new Date(moment.getTime() - 10 * 60000)),
      dateTo: stamp(new Date(moment.getTime() + 10 * 60000)),
      computer: String(item.computerId),
      logId: String(LOG_IDS[item.linkSource]),
      ...(item.recordId ? { record: String(item.recordId) } : {}),
    },
  };
}

/** Report page for the same period (and computer, when the report was built for one). */
export function reportLink(item) {
  const request = (item && item.request) || {};
  const name = REPORT_ROUTES[request.report];
  if (!name || !request.dateFrom || !request.dateTo) return null;
  return {
    name,
    query: {
      dateFrom: normalize(request.dateFrom),
      dateTo: normalize(request.dateTo),
      ...(request.computerId ? { selectedComputerId: String(request.computerId) } : {}),
    },
  };
}
